import BooksIcon from 'assets/icons/books.png';
import StarsIcon from 'assets/icons/stars.png';
import PuzzleIcon from 'assets/icons/puzzle.png';
import SearchIcon from 'assets/icons/search.png';

export const CHATBOT_LOADING_MESSAGES = [
  { icon: SearchIcon, text: 'Analyzing your question…' },
  { icon: BooksIcon, text: 'Researching relevant sources…' },
  { icon: PuzzleIcon, text: 'Piecing together the most useful insights…' },
  { icon: StarsIcon, text: 'Finalizing your answer…' }
];
